import Section from './ColormixForecastSection'
import isEmpty from './ColormixForecastIsEmpty'

export default { Section, isEmpty }
